@if(service.viewDroplistItems.length){
<div class="volunteering-all-volunteers-views-part">

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='uniqueId' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.ApprovedVolunteers) {
	<approved-volunteers-view-part></approved-volunteers-view-part>
	}
	@case (service.viewId.RemovedVolunteers) {
	<removed-volunteers-view-part></removed-volunteers-view-part>
	}
	}
	}

</div>
}